export default __webpack_public_path__ + "static/base-plus-1-4981bba83818cb6cd2e43eed87e681ab.jpg";